import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useParams, useSearchParams } from 'react-router-dom';
import AIPanel from "../../../components/AIChat/AIPanel";
import { Loading } from 'spark-core-dx/components'
import { useCoreStateContext } from 'spark-core-dx/contexts';
import { useCoreRoute } from 'spark-core-dx/hooks'
import { ItemServiceFactory } from '../../../services/ItemServiceFactory';
import PermissionSetEditor from '../../../components/PermissionSetEditor';
import { useGenericManager } from "spark-core-dx/hooks";

const PermissionSetManage = ({ }) => {
  const itemService = new ItemServiceFactory()
  const { coreNavigate } = useCoreRoute();
  const coreState = useCoreStateContext();
  const pageRef = useRef(null);

  const permissionSetMgr = useGenericManager(itemService.ItemServiceEnum.PermissionSet)
  const permissionMgr = useGenericManager(itemService.ItemServiceEnum.Permission)
  const chatSessionMgr = useGenericManager(itemService.ItemServiceEnum.AIChatSession)

  const [permissions, setPermissions] = useState(null);
  const [permissionSet, setPermissionSet] = useState(null);
  const [currentPermissionSet, setCurrentPermissionSet] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState("0");
  const [session, setSession] = useState(null);

  const { id } = useParams();

  // --- guard to avoid feedback loop on onChange ---
  const lastPayloadStrRef = useRef("");

  const setCurrentPermissionSetIfChanged = useCallback((next) => {
    // Avoid exceptions from circulars; if it fails, fall back to reference compare
    let nextStr = "";
    try { nextStr = JSON.stringify(next); } catch { /* ignore */ }

    if (nextStr && nextStr === lastPayloadStrRef.current) return;

    setCurrentPermissionSet(prev => {
      try {
        const prevStr = JSON.stringify(prev);
        if (prevStr === nextStr) return prev; // no structural change
      } catch {
        if (prev === next) return prev;        // fallback to ref compare
      }
      lastPayloadStrRef.current = nextStr || "";
      return next;
    });
  }, []);

  useEffect(() => {
    const getChatSession = async (referenceId) => {
      console.log("get chat Session!!");
      const chatSessionResult = await chatSessionMgr.Query({
        model: "x => x.ReferenceId == referenceId && x.IsDeleted == false && x.IsActive == true",
        params: { referenceId }
      }
      );

      console.log(referenceId);
      console.log(chatSessionResult.Items.length);
      if (chatSessionResult?.Success && chatSessionResult?.Items?.length > 0) {
        setSession(chatSessionResult.Items.first());
      }
    }

    const getPermissionData = async () => {
      const permissionSetData = coreState.get("InternalRedirectData");

      if (!permissions) {
        const r = await permissionMgr.Query("x => x.IsDeleted == false && x.IsActive == true");
        if (r.Success) {
          setPermissions(r.Items);
        }
      }

      if (permissionSetData) {
        if (id === permissionSetData._id) {
          setPermissionSet(permissionSetData);
          setCurrentPermissionSet(permissionSetData);
          await getChatSession(permissionSetData._id);
        }
      }
      else if (id) {
        const r = await permissionSetMgr.getItem(id);
        if (r?.Success) {
          const ps = r.Items.first();
          if (!session) {
            await getChatSession(ps._id);
          }
          setPermissionSet(ps);
          setCurrentPermissionSet(ps);
        }
      }
    }

    if (coreState && !permissions && !permissionSet)
      getPermissionData().then(() => { setIsLoading(false); });
  }, []); // intentionally once

  const onUpdatePanel = async (UICommand, item, value) => {
    if (UICommand === "update" && item?.Entries) {
        setCurrentPermissionSet(item);
        setRefresh(item);
    }
  }

  useEffect(()=>{
    //console.log("permissionSetChanged", permissionSet, refresh);
  },[permissionSet])

  const handleSavePermissionSet = async (updatedPermissionSet) => {
    const result = await permissionSetMgr.saveItem(updatedPermissionSet);
    if (result?.Success) {
      setRefresh(String(Date.now()));
      const saved = result.Items.first();
      setPermissionSet(saved);
      // also advance the "current" model so editor doesn't bounce back
      setCurrentPermissionSetIfChanged(saved);
    }
    return result;
  }

  const handleCurrentPermissionSet = (value) => {
    // NOTE: Avoid deep-cloning every time; only update if structurally different.
    setCurrentPermissionSetIfChanged(value);
  }


  return (
    <>
      {!isLoading ? (
        <AIPanel
          childrenRef={pageRef}
          open={true}
          onUpdatePanel={onUpdatePanel}
          mapToClass={'core-layout'}
          params={{ id }}
          session={session}
          payload={currentPermissionSet}
          referenceId={id}
          enableContentDragHiding ={false}
          minLeftWidth={825}
          minRightWidth={400}
          startChat={!session ? permissionSet?.Description : null}
          referenceName={"PermissionSet"}
          operationName={"AIPermissionSet"}
          splashMessage={"Ready to build your permission set? Let me know the type you’d like, and I’ll take care of the rest!"}
          onCancel={() => { coreNavigate("/dynamic/permissionset/") }}
        >
          <div className="permission-set-editor">
            <PermissionSetEditor
              permissionSet={permissionSet}
              permissions={permissions}
              onSave={handleSavePermissionSet}
              onChange={handleCurrentPermissionSet}
              refresh={refresh}
            />
          </div>
        </AIPanel>
      ) : (
        <div className='centered-loading'>
          <Loading />
        </div>
      )}
    </>
  );
}

export default PermissionSetManage;
